const SW_PATH = '/push-sw.js';

function withTimeout(promise, ms, message) {
  let timer;
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error(message)), ms);
    }),
  ]).finally(() => clearTimeout(timer));
}

function waitForWorkerState(worker, timeoutMs = 10000) {
  if (!worker) {
    return Promise.resolve();
  }
  if (worker.state === 'activated') {
    return Promise.resolve();
  }

  return withTimeout(
    new Promise((resolve, reject) => {
      worker.addEventListener('statechange', () => {
        if (worker.state === 'activated') {
          resolve();
        }
        if (worker.state === 'redundant') {
          reject(new Error('Service worker became redundant.'));
        }
      });
    }),
    timeoutMs,
    'Service worker activation timed out.'
  );
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  const registration = await withTimeout(
    navigator.serviceWorker.register(SW_PATH, {
      scope: '/',
      updateViaCache: 'none',
    }),
    10000,
    'Service worker registration timed out.'
  );

  if (registration.active && !registration.installing && !registration.waiting) {
    return registration;
  }

  const pending = registration.installing || registration.waiting;
  if (pending) {
    pending.postMessage({ type: 'SKIP_WAITING' });
    try {
      await waitForWorkerState(pending);
    } catch (error) {
      console.warn('Service worker did not activate in time', error);
    }
  }

  return registration;
}
